import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Gift } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { RARITY, RarityBadge, CosmeticPreview } from "./Cosmetics";

const LootRevealModal = () => {
  const { user, refresh } = useAuth();
  const [drops, setDrops] = useState([]);

  useEffect(() => {
    if (!user) return;
    api.get("/loot/mine").then((r) => setDrops(r.data.unseen || [])).catch(() => {});
  }, [user?.id]); // eslint-disable-line

  const collect = async () => {
    await api.post("/loot/seen").catch(() => {});
    setDrops([]);
    refresh();
  };

  return (
    <AnimatePresence>
      {drops.length > 0 && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} data-testid="loot-reveal-modal" className="fixed inset-0 z-[90] bg-black/85 backdrop-blur-md flex items-center justify-center px-4">
          <div className="max-w-3xl w-full text-center">
            <motion.div initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} className="overline mb-2 inline-flex items-center gap-2"><Gift className="w-3.5 h-3.5" /> LOOT DROP INCOMING</motion.div>
            <h2 className="font-heading text-3xl sm:text-4xl font-black uppercase mb-8">You earned {drops.length} drop{drops.length > 1 ? "s" : ""}</h2>
            <div className="flex flex-wrap justify-center gap-4 mb-8" style={{ perspective: 1000 }}>
              {drops.map((d, i) => {
                const r = RARITY[d.rarity] || RARITY.common;
                return (
                  <motion.div key={d.id} initial={{ scale: 0.8, opacity: 0, rotateY: 90 }} animate={{ scale: 1, opacity: 1, rotateY: 0 }} transition={{ type: "spring", stiffness: 200, damping: 20, delay: 0.15 + i * 0.2 }}
                    data-testid={`loot-drop-card-${d.id}`} className="w-52 glass tactical-frame p-5 hud-corners" style={{ borderColor: `${r.hex}99`, boxShadow: `0 0 40px ${r.hex}33` }}>
                    <div className="h-20 flex items-center justify-center mb-4"><CosmeticPreview item={d.type === "item" ? d : { kind: "xp", amount: d.amount }} /></div>
                    <div className="font-stencil font-bold uppercase text-sm truncate mb-2">{d.name}</div>
                    <RarityBadge rarity={d.rarity} />
                    <div className="font-mono text-[10px] text-[#64748B] mt-3 uppercase">{d.reason.replace("_", " ")} · {d.map}</div>
                  </motion.div>
                );
              })}
            </div>
            <motion.button initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.6 }} data-testid="loot-drop-collect-button" onClick={collect} className="bg-[#D4A94A] hover:bg-[#E5BD60] text-black font-stencil font-black uppercase px-8 py-3 tactical-frame-sm glow-orange transition-colors">
              Collect
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LootRevealModal;
